export default {
  learnMoreAboutAffirmAriaLabel: {
    id: 'affirm_modal_learn_more_aria_label',
    defaultMessage: 'Learn more about Affirm payment options',
  },
}
